import { LOAD_STATE } from '@shared/axios';
import { staticWidgetListMock } from '@domain/dashboard/big-numbers/big-numbers.mock';

export const userConfigMock = {
    userConfig: {
        data: {
            BIG_NUMBER: staticWidgetListMock,
        },
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    },
};
